import type { PredicateNode } from './types'

function format(node: PredicateNode): string {
  if (node.type === 'true') return 'TRUE'
  if (node.type === 'condition') {
    const v = Array.isArray(node.value)
      ? `[${(node.value as unknown[]).join(', ')}]`
      : (typeof node.value === 'string' ? node.value : String(node.value))
    return `${node.field} ${node.op} ${v}`
  }
  // group
  if (node.children.length === 0) return 'TRUE'
  const inner = node.children.map(format).join(node.connector === 'and' ? ' AND ' : ' OR ')
  return `(${inner})`
}

export function RulePreview({ value }: { value: PredicateNode }) {
  return (
    <pre className="text-[11px] font-mono bg-slate-50 border border-slate-200 rounded p-2 whitespace-pre-wrap">
      {format(value)}
    </pre>
  )
}
